import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
// --- EKLENEN PARÇALAR ---
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo';

// --- API BAĞLANTI AYARI (Senin yazdığın gibi) ---
const BACKEND_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

const AboutPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Backend'den ayarları çekiyoruz
    fetch(`${API}/settings`)
      .then(res => res.json())
      .then(settings => {
        setData(settings);
        setLoading(false);
      })
      .catch(err => {
        console.error("Hata:", err);
        setLoading(false);
      });
  }, []);

  // Eğer veri yoksa varsayılan boş bir obje kullan
  const content = data || {};

  if (loading) return <div className="min-h-screen bg-black text-white flex justify-center items-center">Yükleniyor...</div>;

  return (
    <div className="min-h-screen bg-black text-white flex flex-col justify-between">
      {/* 1. SEO BİLEŞENİ (Google için) */}
      <Seo 
        title={content.about_title || "Hakkımızda"} 
        description={content.about_desc ? content.about_desc.substring(0, 150) : "MERTT - Vizyonumuz ve Misyonumuz."} 
      />

      {/* 2. NAVBAR (Üst Menü) */}
      <Navbar />

      {/* 3. ANA İÇERİK (Senin Orijinal Kodun) */}
      <div className="flex-grow flex items-center justify-center pt-24 px-6">
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8 }}
          className="max-w-4xl text-center"
        >
          {/* Dinamik Başlık */}
          <h1 className="text-5xl md:text-7xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-blue-500">
            {content.about_title || "MERTT"}
          </h1>
          
          {/* Dinamik Açıklama */}
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-10 whitespace-pre-line">
            {content.about_desc || "Teknoloji ve inovasyonun buluşma noktası."}
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left mt-16">
            {/* Vizyon */}
            <div className="p-6 bg-gray-900 rounded-xl border border-gray-800 hover:border-blue-500 transition group">
              <h3 className="text-2xl font-bold mb-2 text-blue-400 group-hover:text-blue-300">Vizyonumuz</h3>
              <p className="text-gray-400 whitespace-pre-line">
                {content.vision || "Geleceği şekillendiren teknolojiler üretmek."}
              </p>
            </div>

            {/* Misyon */}
            <div className="p-6 bg-gray-900 rounded-xl border border-gray-800 hover:border-purple-500 transition group">
              <h3 className="text-2xl font-bold mb-2 text-purple-400 group-hover:text-purple-300">Misyonumuz</h3>
              <p className="text-gray-400 whitespace-pre-line">
                {content.mission || "Müşterilerimize en iyi dijital deneyimi sunmak."}
              </p>
            </div>

            {/* Değerler */}
            <div className="p-6 bg-gray-900 rounded-xl border border-gray-800 hover:border-green-500 transition group">
              <h3 className="text-2xl font-bold mb-2 text-green-400 group-hover:text-green-300">Değerlerimiz</h3>
              <p className="text-gray-400 whitespace-pre-line">
                {content.values || "Şeffaflık, Güven ve Sürekli Gelişim."}
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      {/* 4. FOOTER (Alt Menü) */}
      <Footer />
    </div>
  );
};

export default AboutPage;